export default {"src":"/_next/static/media/hero-connector.d73e8567.svg","height":357,"width":1557,"blurWidth":0,"blurHeight":0};